import { useQuery } from "@tanstack/react-query";
import { ApiError, ApiServiceError, GetListResponse } from "libs/api";
import { QueryOptions } from "libs/reactQuery";

import { TransactionItem } from "../../financial.types";
import { requestTransactions } from "./transactions.request";
import { TransactionsRequestParams } from "./transactions.types";

const useTransactions = (
  requestParams: TransactionsRequestParams,
  options?: QueryOptions<
    GetListResponse<TransactionItem>,
    ApiServiceError<ApiError>
  >
) => {
  const { data, ...rest } = useQuery({
    queryKey: ["transactions", requestParams],
    queryFn: async () => await requestTransactions(requestParams),
    ...options
  });

  return { transactions: data?.data ?? [], meta: data?.meta, ...rest };
};

export default useTransactions;
